import axios from "axios";
import { MasterDataURL } from "../../../../config/UrlEndPoint";

export const URL = `${MasterDataURL}project_category`;

// //Get By ID
export function getProjectCategoryById(projectCategoryId) {
  return axios.get(`${URL}/${projectCategoryId}`);
}

export function getProjectCategory() {
  return axios.get(`${URL}`);
}

// items => filtered/sorted result for table data
export function findProjectCategory(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the project on the server
export function createProjectCategory(project) {
  return axios.post(URL, project);
}

// UPDATE => PUT: update the project on the server
export function updateProjectCategory(project) {
  return axios.put(`${URL}/${project.uuid}`, project);
}

export function deleteProjectCategory(uuid) {
  return axios.delete(`${URL}/${uuid}`);
}
